
<section class="border-t-10 border-b-10 border-primary border-double wow animate__animated animate__fadeInUp"  data-wow-delay="0.5s">
    
    <div class="w-full grid grid-cols-12 items-center gap-5  md:gap-10 py-10 px-5 md:p-10 flex-wrap lg:flex-nowrap">
        <div class="col-span-12 md:col-span-5 mockup relative bg-primary border-r-18 border-l-18 border-base-100 border-dotted outline-offset-[-3px] outline-5 outline-base-100 p-3 md:p-5" >
           <div class="content border-3 border-base-100 m-5 rounded-2xl flex flex-col justify-center items-center py-2 md:py-3">
               <div class="text-2xl mb-1">
                    <ng-icon name="faSolidStar" size="16" color="var(--color-base-100)"/>
                    <ng-icon name="faSolidStar" color="var(--color-base-100)" />
                    <ng-icon name="faSolidStar" size="40" color="var(--color-base-100)"/>
                    <ng-icon name="faSolidStar" color="var(--color-base-100)"/>
                    <ng-icon name="faSolidStar" size="16" color="var(--color-base-100)"/>

               </div>
                <h2 class="text-3xl font-bold tracking-widest color-base-content">CINEMA</h2>
                <p class="text-lg mt-1 tracking-wider border-b-2 border-base-100">FREE PASS</p>
             <img src="/images/homePage/mockup-Photoroom.png" alt="mockup" class="h-[160px] w-full" >
           </div>

            
            <div class="absolute top-0 left-0 transform -translate-x-1/2 -translate-y-1/3 w-[60px] h-[60px] md:w-[75px] md:h-[75px] rounded-full bg-base-100"></div>
            <div class="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/3 w-[60px] h-[60px] md:w-[75px] md:h-[75px] rounded-full bg-base-100"></div>
            <div class="absolute bottom-0 left-0 transform -translate-x-1/2 translate-y-1/3 w-[60px] h-[60px] md:w-[75px] md:h-[75px] rounded-full bg-base-100"></div>
            <div class="absolute bottom-0 right-0 transform translate-x-1/2 translate-y-1/3 w-[60px] h-[60px] md:w-[75px] md:h-[75px] rounded-full bg-base-100"></div>
        </div>
        <div class="col-span-12 md:col-span-6 color-primary-content">
            <h3 class="text-xl md:text-3xl  font-bold mb-2">We Provide you streaming experience across various devices.</h3>
            <p class="text-sm ">With Blockbuster, you can enjoy your favorite movies and TV shows anytime, anywhere. Our platform is designed to be compatible with a wide range of devices,
                ensuring that you never miss a moment of entertainment.</p>
        </div>
    </div>
</section>

